<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless">
    <div class="column is-12 pdb-0">
      <a @click="$emit('togglePanier')">
        <b-icon class="icon is-pulled-right has-text-icon-more"
                icon="close"></b-icon>
      </a>
      <span class="mgl-10px has-text-weight-bold is-size-4">
          {{$t('listeProduitReseauTempoDispo.panier.title')}}
        </span>
    </div>
    <div class="column is-12 border-entete pdt-0">
        <span class="mgl-10px is-size-6">
          {{ $t('listeProduitReseauTempoDispo.panier.sousTitle',
          { numberProduit: panier.length }) }}
        </span>
    </div>
    <div class="column is-12-tablet hauteur-brief-filtre is-marginless"
         v-if="panier.length > 0">
      <div class="overflow-auto">
        <display-ligne-in-panier-reseau-tempo-dispo />
      </div>
    </div>
    <div class="column is-12 hauteur-brief-filtre is-flex" v-else>
      <div class="has-text-centered mg-auto">
        <div class="logo__panier_vide mg-auto"></div>
        <p class="has-text-weight-bold is-size-5">
          {{$t('listeProduitReseauTempoDispo.panier.panierVide')}}
        </p>
        <p>{{$t('listeProduitReseauTempoDispo.panier.noProduct')}}</p>
      </div>
    </div>
    <div class="column is-12 hauteur-bas-brief-filtre
    border-pied columns is-marginless is-vcentered level">
      <button class="button pdv-0 column is-narrow pdh-20px
      level-left" @click="$emit('parametrageSelection')"
              :class="[{'is-select pointer-events-none': panier.length === 0},
        {'is-addOrEdit': panier.length > 0}]">
        {{$t('listeProduitReseauTempoDispo.panier.actions.parametrer')}}
      </button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import displayLigneInPanierReseauTempoDispo from '@/components/outils/reseauTempo/displayLigneInPanierReseauTempoDispo';

const ProduitReseauTempo = createNamespacedHelpers('produitReseauTempo');

export default {
  components: {
    displayLigneInPanierReseauTempoDispo,
  },
  computed: {
    ...ProduitReseauTempo.mapGetters({
      panier: 'panier',
    }),
  },
};

</script>
